// SNMP OID Library - Common OIDs for various vendors and device types

export const SNMP_OID_LIBRARY = {
  // Generic/Standard OIDs (RFC 1213 - MIB-II)
  generic: {
    name: "Generic SNMP (Any Device)",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Time since device boot" },
      { name: "System Description", oid: "1.3.6.1.2.1.1.1.0", description: "Device description" },
      { name: "System Name", oid: "1.3.6.1.2.1.1.5.0", description: "Device hostname" },
      { name: "System Location", oid: "1.3.6.1.2.1.1.6.0", description: "Physical location" },
      { name: "System Contact", oid: "1.3.6.1.2.1.1.4.0", description: "Contact person" },
      { name: "Interface Status", oid: "1.3.6.1.2.1.2.2.1.8", description: "Network interface status" },
      { name: "Interface In Octets", oid: "1.3.6.1.2.1.2.2.1.10", description: "Bytes received" },
      { name: "Interface Out Octets", oid: "1.3.6.1.2.1.2.2.1.16", description: "Bytes sent" },
    ]
  },

  // Ubiquiti UniFi Devices
  unifi: {
    name: "Ubiquiti UniFi",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Device uptime" },
      { name: "Device Model", oid: "1.3.6.1.2.1.1.1.0", description: "UniFi device model" },
      { name: "Firmware Version", oid: "1.3.6.1.4.1.41112.1.6.3.3.0", description: "Current firmware" },
      { name: "CPU Usage", oid: "1.3.6.1.4.1.2021.11.9.0", description: "CPU load percentage" },
      { name: "Memory Total", oid: "1.3.6.1.4.1.2021.4.5.0", description: "Total memory (KB)" },
      { name: "Memory Free", oid: "1.3.6.1.4.1.2021.4.6.0", description: "Free memory (KB)" },
      { name: "Client Count (AP)", oid: "1.3.6.1.4.1.41112.1.6.1.2.1.8", description: "Connected clients" },
      { name: "Wireless Interface Status", oid: "1.3.6.1.4.1.41112.1.6.1.2.1.3", description: "WiFi status" },
    ]
  },

  // Cisco Devices
  cisco: {
    name: "Cisco (Switches/Routers)",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Device uptime" },
      { name: "CPU 5sec Average", oid: "1.3.6.1.4.1.9.2.1.56.0", description: "CPU usage (5s avg)" },
      { name: "CPU 1min Average", oid: "1.3.6.1.4.1.9.2.1.57.0", description: "CPU usage (1m avg)" },
      { name: "Memory Pool Used", oid: "1.3.6.1.4.1.9.9.48.1.1.1.5.1", description: "Used memory" },
      { name: "Memory Pool Free", oid: "1.3.6.1.4.1.9.9.48.1.1.1.6.1", description: "Free memory" },
      { name: "Temperature", oid: "1.3.6.1.4.1.9.9.13.1.3.1.3.1", description: "Device temperature" },
      { name: "Fan Status", oid: "1.3.6.1.4.1.9.9.13.1.4.1.3.1", description: "Fan operational status" },
      { name: "Power Supply Status", oid: "1.3.6.1.4.1.9.9.13.1.5.1.3.1", description: "PSU status" },
    ]
  },

  // DrayTek Routers
  draytek: {
    name: "DrayTek Routers",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Device uptime" },
      { name: "Device Model", oid: "1.3.6.1.4.1.12673.1.1.0", description: "Router model" },
      { name: "Firmware Version", oid: "1.3.6.1.4.1.12673.1.2.0", description: "Firmware version" },
      { name: "WAN IP Address", oid: "1.3.6.1.4.1.12673.1.8.1.0", description: "WAN IP" },
      { name: "VPN Tunnel Status", oid: "1.3.6.1.4.1.12673.6.1.3.1.2", description: "VPN connection status" },
      { name: "System Load Average", oid: "1.3.6.1.4.1.2021.10.1.3.1", description: "System load" },
    ]
  },

  // WatchGuard Firewalls
  watchguard: {
    name: "WatchGuard Firewalls",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Firewall uptime" },
      { name: "Device Model", oid: "1.3.6.1.4.1.3097.1.1.0", description: "WatchGuard model" },
      { name: "Firmware Version", oid: "1.3.6.1.4.1.3097.1.2.0", description: "Fireware version" },
      { name: "Active Connections", oid: "1.3.6.1.4.1.3097.6.3.1.0", description: "Current connections" },
      { name: "CPU Usage", oid: "1.3.6.1.4.1.3097.6.3.77.0", description: "CPU utilization" },
      { name: "Memory Usage", oid: "1.3.6.1.4.1.3097.6.3.78.0", description: "Memory utilization" },
      { name: "VPN Tunnels Up", oid: "1.3.6.1.4.1.3097.6.5.1.2.1.3", description: "Active VPN tunnels" },
    ]
  },

  // HP/Aruba Switches
  hp_aruba: {
    name: "HP/Aruba Switches",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Switch uptime" },
      { name: "CPU Usage", oid: "1.3.6.1.4.1.11.2.14.11.5.1.9.6.1.0", description: "CPU utilization" },
      { name: "Memory Total", oid: "1.3.6.1.4.1.11.2.14.11.5.1.1.2.1.1.1.1", description: "Total memory" },
      { name: "Memory Free", oid: "1.3.6.1.4.1.11.2.14.11.5.1.1.2.1.1.1.2", description: "Free memory" },
      { name: "Temperature", oid: "1.3.6.1.4.1.11.2.14.11.1.2.6.1.4.1", description: "Switch temperature" },
      { name: "Fan Status", oid: "1.3.6.1.4.1.11.2.14.11.1.2.6.1.4.2", description: "Fan operational" },
    ]
  },

  // Synology NAS
  synology: {
    name: "Synology NAS",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "NAS uptime" },
      { name: "System Status", oid: "1.3.6.1.4.1.6574.1.1.0", description: "Overall system status" },
      { name: "Model Name", oid: "1.3.6.1.4.1.6574.1.5.1.0", description: "NAS model" },
      { name: "DSM Version", oid: "1.3.6.1.4.1.6574.1.5.3.0", description: "DSM version" },
      { name: "CPU Temperature", oid: "1.3.6.1.4.1.6574.1.2.0", description: "CPU temp (°C)" },
      { name: "Disk Status", oid: "1.3.6.1.4.1.6574.2.1.1.5", description: "Disk health status" },
      { name: "RAID Status", oid: "1.3.6.1.4.1.6574.3.1.1.3", description: "RAID array status" },
      { name: "Fan Status", oid: "1.3.6.1.4.1.6574.1.4.1.0", description: "Cooling fan status" },
    ]
  },

  // APC UPS
  apc_ups: {
    name: "APC UPS",
    oids: [
      { name: "Battery Status", oid: "1.3.6.1.4.1.318.1.1.1.2.1.1.0", description: "Battery condition" },
      { name: "Battery Capacity", oid: "1.3.6.1.4.1.318.1.1.1.2.2.1.0", description: "Battery % remaining" },
      { name: "Battery Temperature", oid: "1.3.6.1.4.1.318.1.1.1.2.2.2.0", description: "Battery temp (°C)" },
      { name: "Input Voltage", oid: "1.3.6.1.4.1.318.1.1.1.3.2.1.0", description: "Input voltage (V)" },
      { name: "Output Voltage", oid: "1.3.6.1.4.1.318.1.1.1.4.2.1.0", description: "Output voltage (V)" },
      { name: "Output Load", oid: "1.3.6.1.4.1.318.1.1.1.4.2.3.0", description: "Load percentage" },
      { name: "Time On Battery", oid: "1.3.6.1.4.1.318.1.1.1.2.1.2.0", description: "Time running on battery" },
      { name: "Runtime Remaining", oid: "1.3.6.1.4.1.318.1.1.1.2.2.3.0", description: "Estimated runtime" },
    ]
  },

  // HP Printers
  hp_printer: {
    name: "HP Printers",
    oids: [
      { name: "Device Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Printer uptime" },
      { name: "Printer Status", oid: "1.3.6.1.2.1.25.3.5.1.1.1", description: "Current printer status" },
      { name: "Total Page Count", oid: "1.3.6.1.2.1.43.10.2.1.4.1.1", description: "Total pages printed" },
      { name: "Black Toner Level", oid: "1.3.6.1.2.1.43.11.1.1.9.1.1", description: "Black toner %" },
      { name: "Cyan Toner Level", oid: "1.3.6.1.2.1.43.11.1.1.9.1.2", description: "Cyan toner %" },
      { name: "Magenta Toner Level", oid: "1.3.6.1.2.1.43.11.1.1.9.1.3", description: "Magenta toner %" },
      { name: "Yellow Toner Level", oid: "1.3.6.1.2.1.43.11.1.1.9.1.4", description: "Yellow toner %" },
    ]
  },

  // pfSense Firewall
  pfsense: {
    name: "pfSense Firewall",
    oids: [
      { name: "System Uptime", oid: "1.3.6.1.2.1.1.3.0", description: "Firewall uptime" },
      { name: "CPU Usage", oid: "1.3.6.1.4.1.2021.11.9.0", description: "CPU load" },
      { name: "Memory Total", oid: "1.3.6.1.4.1.2021.4.5.0", description: "Total memory (KB)" },
      { name: "Memory Free", oid: "1.3.6.1.4.1.2021.4.6.0", description: "Free memory (KB)" },
      { name: "Active States", oid: "1.3.6.1.4.1.12325.1.200.1.3.1.0", description: "Firewall states" },
      { name: "Packets Blocked", oid: "1.3.6.1.4.1.12325.1.200.1.2.6.0", description: "Blocked packet count" },
    ]
  },
};

export const EXTERNAL_OID_RESOURCES = [
  {
    name: "OID Repository (oid-info.com)",
    url: "http://oid-info.com/",
    description: "Comprehensive OID database with search functionality"
  },
  {
    name: "Circitor OID Reference",
    url: "http://www.circitor.fr/Mibs/Mibs.php",
    description: "Browse vendor MIBs and OIDs by manufacturer"
  },
  {
    name: "SNMP Link - MIB Database",
    url: "http://www.snmplink.org/",
    description: "Searchable MIB and OID reference"
  },
  {
    name: "SNMP OID Search",
    url: "https://snmp.cloudapps.cisco.com/",
    description: "Cisco's SNMP OID search tool"
  }
];

export const getVendorOids = (vendorKey) => {
  return SNMP_OID_LIBRARY[vendorKey] || null;
};

export const getAllVendors = () => {
  return Object.keys(SNMP_OID_LIBRARY).map(key => ({
    key,
    name: SNMP_OID_LIBRARY[key].name
  }));
};
